import {Entity} from '../../core/commons/entity';
import {DocumentCategory} from "./documentCategory";
import {User} from "../../core/domain/user";

/**
 * Created by Lauta on 17/10/2017.
 */
export class Document implements Entity {
    id: number;
    name: string;
    description: string;
    author: string = null;
    keywords: string[] = [];
    createDate : number;
    uploadUser : User;
    category: DocumentCategory;
    selected: boolean = false;

    constructor(value: Object = {}) {
        Object.assign(this, value);
        if (this.uploadUser)
            this.uploadUser = new User(this.uploadUser);
        if (this.category)
            this.category = new DocumentCategory(this.category);
    }

    public getFileName() : string{
        return this.name.replace(/ /g,"-")+".pdf";
    }

    public changeSelectedState() : void {
        this.selected = ! this.selected;
    }

    public isSelected() : boolean {
        return this.selected;
    }


}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/document.ts